import React from "react";
import bfsiImg from "../../assets/RPA/bfsi-featured.jpg";
import healthcareImg from "../../assets/RPA/healthcare-featured.png";
import sapImg from "../../assets/RPA/sap-featured.jpg";

const FeaturedRPA = () => {
  return (
    <section className="bg-[#eff6e7] py-16 px-6 md:px-12 lg:px-24 overflow-hidden">
      <div className="max-w-[1440px] mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-6 items-stretch">
          {/* BFSI - Large Square Block (Left) */}
          <div className="md:col-span-5 h-[400px] md:h-[552px] relative overflow-hidden rounded-[28px] bg-[#1b5e20] shadow-xl group">
            <img
              src={bfsiImg}
              alt="BFSI Automation"
              className="absolute inset-0 w-full h-full object-cover group-hover:scale-110 transition-transform duration-700"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-[#1b5e20]/80 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity p-8 flex flex-col justify-end">
              <h3 className="text-white text-3xl font-bold manrope">BFSI</h3>
              <p className="text-white/80 text-sm mt-2">
                Revolutionizing banking and insurance with agentic workflows.
              </p>
            </div>
          </div>

          <div className="md:col-span-7 flex flex-col gap-6">
            {/* Healthcare - Wide Horizontal Block (Top Right) */}
            <div className="h-[250px] md:h-[264px] relative overflow-hidden rounded-[28px] bg-[#1b5e20] shadow-xl group">
              <img
                src={healthcareImg}
                alt="Healthcare Automation"
                className="absolute inset-0 w-full h-full object-cover group-hover:scale-110 transition-transform duration-700"
              />
              <div className="absolute inset-0 bg-gradient-to-r from-[#1b5e20]/80 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity p-8 flex flex-col justify-center max-w-[50%]">
                <h3 className="text-white text-3xl font-bold manrope">
                  Healthcare
                </h3>
                <p className="text-white/80 text-sm mt-2">
                  Automating high-trust medical data paths.
                </p>
              </div>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-12 gap-6 grow">
              {/* SAP - Medium Horizontal Block (Bottom Middle) */}
              <div className="sm:col-span-8 h-[250px] md:h-[264px] relative overflow-hidden rounded-[28px] bg-[#1b5e20] shadow-xl group">
                <img
                  src={sapImg}
                  alt="SAP Automation"
                  className="absolute inset-0 w-full h-full object-cover group-hover:scale-110 transition-transform duration-700"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#1b5e20]/80 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity p-8 flex flex-col justify-end">
                  <h3 className="text-white text-3xl font-bold manrope">SAP</h3>
                  <p className="text-white/80 text-sm mt-2">
                    Deep ERP orchestration and automation.
                  </p>
                </div>
              </div>

              {/* See All - Small Card (Bottom Right) */}
              <div className="sm:col-span-4 h-[150px] md:h-[264px] bg-[#1b5e20] rounded-[28px] flex flex-col items-center justify-center p-6 shadow-xl group cursor-pointer hover:bg-[#144a18] transition-colors relative overflow-hidden">
                {/* Decorative Ellipses matching Figma */}
                <div className="absolute -top-10 -right-10 w-24 h-24 bg-[#f6e550] opacity-10 rounded-full blur-xl group-hover:scale-150 transition-transform"></div>

                <div className="flex items-center gap-3 bg-[#5a8031] border border-[#809e5d] px-6 py-3 rounded-full text-white font-medium group-hover:bg-[#6c9640] transition-colors shadow-lg z-10 transition-transform active:scale-95">
                  <span className="text-lg manrope font-semibold">See All</span>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="22"
                    height="22"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="3"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <line x1="5" y1="12" x2="19" y2="12"></line>
                    <polyline points="12 5 19 12 12 19"></polyline>
                  </svg>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FeaturedRPA;
